module.exports = __webpack_public_path__ + "static/parenie-01176e22015bc26a0b8e3a657668f779.webp";